import { render, staticRenderFns } from "./Listagem-SESI.vue?vue&type=template&id=4277a8b1&scoped=true&"
import script from "./Listagem-SESI.vue?vue&type=script&lang=js&"
export * from "./Listagem-SESI.vue?vue&type=script&lang=js&"
import style0 from "./Listagem-SESI.vue?vue&type=style&index=0&id=4277a8b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4277a8b1",
  null
  
)

export default component.exports